import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {SelectionModel} from "@angular/cdk/collections";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../shared/services/auth.service";
import {FilterService} from "../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {delay, distinctUntilChanged, takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {PartnerTagsImport} from "../../../shared/interface/partner-tags-import";
import {PartnerTagsImportService} from "../../../shared/services/partner-tags-import.service";
import {PartnerTagsImportComponent} from "../partner-tags-import/partner-tags-import.component";
import {IMPORT_STATUS_IN_PROGRESS} from "../../../shared/services/dict.service";

@Component({
  selector: 'app-all-partner-tags',
  templateUrl: './all-partner-tags-import.component.html',
  styleUrls: ['./all-partner-tags-import.component.scss']
})
export class AllPartnerTagsImportComponent implements  AfterViewInit, OnDestroy {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  selection = new SelectionModel<PartnerTagsImport>(false, []);
  initialFilters: any;
  imports: PartnerTagsImport[] = [];
  displayedColumns: string[] = [
    'fileName', 'assignTag', 'synchronizeTag', 'rowsCount', 'createdAt', 'createdBy', 'status', 'actions'
  ];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;

  readonly IMPORT_STATUS_IN_PROGRESS = IMPORT_STATUS_IN_PROGRESS;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private partnerTagsImportService: PartnerTagsImportService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.partnerTagsImportService.importListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<PartnerTagsImport>) => {
          this.imports = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }


  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({}, filters);
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadListData(): void {
    this.partnerTagsImportService.loadImportList(this.paginator.pageIndex, this.paginator.pageSize, this.initialFilters);
  }

  filter(): void {
    if (this.paginator.pageIndex === 0) {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
        ...this.filtersForm.value
      })]);
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: 0,
        pageSize: this.paginator.pageSize,
        ...this.filtersForm.value,
      })]);
    }
  }

  import(): void {
    const dialogRef = this.dialog.open(PartnerTagsImportComponent, {
      width: '55%',
      data: {},
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadListData();
    });

    dialogRef.componentInstance.importCompleted.subscribe(() => {
      this.loadListData();
    });
  }

  download(uuid: string): void {
    this.partnerTagsImportService.downloadImportFile(uuid);
  }
}
